export const FETCH_DISCONTINUED_TEST_DIRECTORIES_REQUEST = "FETCH_DISCONTINUED_TEST_DIRECTORIES_REQUEST";
export const FETCH_DISCONTINUED_TEST_DIRECTORIES_SUCCESS = "FETCH_DISCONTINUED_TEST_DIRECTORIES_SUCCESS";
export const FETCH_DISCONTINUED_TEST_DIRECTORIES_FAILURE = "FETCH_DISCONTINUED_TEST_DIRECTORIES_FAILURE";

